import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown float-end" }
const _hoisted_2 = {
  id: "userMenuButton",
  class: "btn btn-default dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-offset": "-330,1"
}
const _hoisted_3 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "userMenuButton"
}
const _hoisted_4 = {
  key: 0,
  class: "dropdown-item"
}
const _hoisted_5 = { class: "dropdown-item" }
const _hoisted_6 = {
  key: 1,
  class: "dropdown-item"
}
const _hoisted_7 = {
  key: 2,
  class: "dropdown-item"
}
const _hoisted_8 = {
  key: 3,
  class: "dropdown-item"
}
const _hoisted_9 = {
  key: 4,
  class: "dropdown-item",
  "data-is": "menu_qa"
}
const _hoisted_10 = {
  class: "dropdown-item",
  "data-is": "menu_qa"
}
const _hoisted_11 = { class: "dropdown-item" }

import { useRouter, useRoute } from 'vue-router';
import { SessionUser } from "../../../utils/SessionUser";
import { DialogHandler } from "../../dialog/DialogHandler";
import { Permission } from "../../../utils/Permission";
import { translation } from "../../../lang/Translation";
import { SessionMemory } from '../../../utils/SessionMemory';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMenuButton',
  setup(__props) {

const t = translation;
const router = useRouter();
const userEditTitleButton = t.to("ユーザー情報の編集", "user_edit");
const qaMenuButtonTitle = t.to("お問い合わせ", "qa");
const modelUploadTitleButton = t.to("プリセットファイルアップロード", "preset_upload");
const signOutMenuButtonTitle = t.to("サインアウト", "signout");
const fileUploadButtonTitle = t.to("3Dモデル、画像、動画、音楽のファイル(マイアセット)", "file_manager");
// const wordToCanvasArTitle = t.to("文字で絵を描いてARを作る","word_to_canvas_ar");

const route = useRoute();

const signOut = () => {
  SessionUser.instance.clearSession();
  location.href = "/";
};

const userList = () => {
  router.push({ name: "UserListPage" });
};

const editUser = () => {
  router.push({ name: "EditUserPage", params: { user_id: SessionUser.instance.userId } });
};

const modelUpload = () => {
  router.push({ name: "3DmodelUpload" });
};
const classRoom = () => {
  DialogHandler.showClassRoomDialog();
};
const openClassRoomPresentation = () => {
  router.push({name:"ClassPresentationPage"})
};

const openContact = () => {
  DialogHandler.showContactUsDialog();
};

const changePlan = () => {
  SessionMemory.instance.paymentBackPage = route.fullPath;
  router.push({ name: "ChangePlanPage" });
};

const fileUpload = () => {
  
  router.push({ name: "FileManagerPage" , params: { project_id : "no_project_id" }, query:{"page":"user"}});
};

// const toWordToCanvasAr = ()=>{
//   router.push({ name: "WordToCanvasAr" });
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, _toDisplayString(_unref(t).to("ユーザー", "user")), 1),
    _createElementVNode("ul", _hoisted_3, [
      (_unref(Permission).allAccountedUser)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: editUser
            }, _toDisplayString(_unref(userEditTitleButton)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: fileUpload
        }, _toDisplayString(_unref(fileUploadButtonTitle)), 1)
      ]),
      (_unref(Permission).onlyAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: changePlan
            }, _toDisplayString(_unref(t).to("料金プラン変更", "plan_change")), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(Permission).onlyTeacherAndAdmin )
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: classRoom
            }, _toDisplayString(_unref(t).to("クラスルーム", "class_room")), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(Permission).onlyAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: userList
            }, _toDisplayString(_unref(t).to("ユーザ一覧", "user_list")), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(Permission).onlyAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: modelUpload
            }, _toDisplayString(_unref(modelUploadTitleButton)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("button", {
          class: "btn btn-default",
          "data-toggle": "dropdown",
          onClick: openContact
        }, _toDisplayString(_unref(qaMenuButtonTitle)), 1)
      ]),
      _createElementVNode("li", _hoisted_11, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: signOut
        }, _toDisplayString(_unref(signOutMenuButtonTitle)), 1)
      ])
    ])
  ]))
}
}

})